export default "__VITE_ASSET__Cxj2FYR$__"